/** The Matchup copy of the scoring summary (ISSUE-989). Below lg it is the only place a phone shows the scoring; at lg it hides when GameDetailScreen's desktop column already renders SummaryTab, so the scoring never shows twice (card R6). */
import type { ReactNode } from "react";

import { SummaryTab, type typeSummaryEntry } from "./SummaryTab";
import { GameSectionCard } from "./GameSectionCard";

export const ScoringSummarySection = ({
  title,
  entries,
  isHiddenAtLg,
}: {
  title: string;
  entries: readonly typeSummaryEntry[];
  isHiddenAtLg: boolean;
}): ReactNode => (
  <GameSectionCard
    testId="matchup-scoring-summary"
    title={title}
    className={isHiddenAtLg ? "lg:hidden" : undefined}
  >
    <SummaryTab entries={entries} variant="embedded" />
  </GameSectionCard>
);
